/**
 * cleanCompanyName — 회사명 표기 정리
 *
 * 형식적/법적 접미사 제거로 길이 축소 + 깔끔한 표시.
 * 예: "AST SpaceMobile, Inc. Class A Common Stock" → "AST SpaceMobile"
 *     "Apple Inc." → "Apple"
 *     "Tesla, Inc. Common Stock" → "Tesla"
 *     "Taiwan Semiconductor Manufacturing Company Limited" → "Taiwan Semiconductor Manufacturing"
 *
 * 제거 패턴 (뒤에서 앞으로 순차적용):
 *  · 주식 종류: "Common Stock" / "Preferred Stock" / "Class A/B/C"
 *  · ADR 표기: "American Depositary Shares" / "ADR"
 *  · 법인격: "Inc." / "Corp." / "Corporation" / "Ltd." / "Limited" / "Co." / "Company" /
 *            "Holdings" / "Holding" / "Group" / "PLC" / "S.A." / "N.V." / "AG"
 */
export function cleanCompanyName(name: string | null | undefined): string {
  if (!name || typeof name !== "string") return "";
  let s = name.trim();
  // 반복 적용 — "Corporation - Common Stock" 같은 복합 접미사 커버.
  for (let i = 0; i < 5; i++) {
    const prev = s;
    s = s
      // " - Class A" / " Class A" / " - CLASS A" 등 클래스 표기 제거
      .replace(/\s*[-–—|·]\s*Class\s+[A-Z]\s*(Common|Preferred)?\s*Stock?\s*$/i, "")
      .replace(/\s*[-–—|·]\s*(Common|Preferred)\s+Stock\s*$/i, "")
      .replace(/\s+Class\s+[A-Z]\s*(Common|Preferred)?\s*Stock?\s*$/i, "")
      .replace(/\s+(Common|Preferred)\s+Stock\s*$/i, "")
      // ADR 표기
      .replace(/\s+American\s+Depositary\s+Shares\s*$/i, "")
      .replace(/\s+ADR\s*$/i, "")
      // 법인격 — INCORPORATED · CORPORATION 풀네임 / 약어 모두
      .replace(/,?\s+(Incorporated|INCORPORATED|Inc|Corp|Corporation|CORPORATION|Ltd|Limited|LIMITED|Co|Company|Holdings|HOLDINGS|Holding|Group|GROUP|PLC|S\.?A\.?|N\.?V\.?|AG|AB)\.?\s*$/i, "")
      // 말미 정리
      .replace(/\s*[-–—|·,.]+\s*$/g, "")
      .replace(/\s+$/g, "");
    if (s === prev) break;
  }
  // ALL CAPS 인 경우 (SOFI TECHNOLOGIES → Sofi Technologies) Title Case 변환
  // 단어가 2개 이상이고 모두 대문자일 때만 적용. 약어 (IBM, GE) 는 그대로.
  if (s.length > 4 && s === s.toUpperCase() && /\s/.test(s)) {
    s = s
      .toLowerCase()
      .split(/(\s+|[-/])/)
      .map((w) => (w.match(/^\s+|^[-/]$/) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
      .join("");
  }
  return s || name;
}
